import { UserRole } from '@synergy/models';
import { UserStatus } from '@synergy/models';

import { Contact } from '../models/contact';
import { LoginUser, isLoginUser } from '../../features/contacts-logins/models/login-user';

export const getUserStatus = (contact: Contact | LoginUser): UserStatus => {
    if (!isLoginUser(contact)) {
        return UserStatus.NoUser;
    }

    if (!contact.user.isActivated) {
        return UserStatus.NotActivated;
    }

    if (contact.user.roles?.includes(UserRole.ShopAdmin)) {
        return UserStatus.ShopAdmin;
    }

    return UserStatus.ShopUser;
};
